module.exports = __webpack_public_path__ + "static/media/queue_play_next_FILL0_wght300_GRAD0_opsz24.c38edabd.svg";